import type { TFetchError } from "@lib/api-fetcher/types";

import { OrderFields } from "../constants";
import type { TOffersResult } from "../types";

const mapOffersErrorsToErrorMessages = (
  errorResponse: TFetchError
): Pick<TOffersResult, "errorMessage" | "fieldErrors"> => {
  if (!errorResponse.response) {
    return {};
  }
  const { data } = errorResponse.response;
  const errorMessage = data?.title;
  const errorDetails = data?.detail;

  const fieldErrors = {
    [OrderFields.STARTING_COUNTRY]: errorDetails?.countryFrom,
    [OrderFields.DESTINATION_COUNTRY]: errorDetails?.countryTo,
    [OrderFields.PACKAGE_SIZE]: errorDetails?.dimension,
  };

  return { errorMessage, fieldErrors };
};
export default mapOffersErrorsToErrorMessages;
